import { useEffect } from 'react';
import { triggerTracking } from '@zoopla/tracking';

interface TrackData {
    event: 'GAEvent';
    eventCategory: string;
    eventAction: string;
    eventLabel?: string;
    eventValue?: number;
}

// TODO: ZDSU is this used?
function getTrackData(el: HTMLElement) {
    const trackData: TrackData = {
        event: 'GAEvent',
        eventCategory: el.dataset.trackCategory || '',
        eventAction: el.dataset.trackAction || ''
    };

    if (el.dataset.trackLabel) {
        trackData.eventLabel = el.dataset.trackLabel;
    }

    if (el.dataset.trackValue) {
        trackData.eventValue = Number(el.dataset.trackValue) || 0;
    }

    return trackData;
}

function pushTrackingObj(e: Event) {
    if (e.target instanceof HTMLElement && e.target.dataset?.trackCategory) {
        triggerTracking(getTrackData(e.target));
    }
}

const useAnalytics = () => {
    useEffect(() => {
        document.addEventListener('click', pushTrackingObj);
        return () => {
            document.removeEventListener('click', pushTrackingObj);
        };
    }, []);
};

export default useAnalytics;
